import { lazy } from "react";
// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const loadLegacyTTInstantiate = ()=>retry(()=>import(/* webpackChunkName: "uno-legacyttinstantiate" */ "@ms/uno-teamstasks-web/lib/ui/adapter/instantiate"));
export const loadLegacyTTRenderer = ()=>retry(()=>import(/* webpackChunkName: "uno-legacyttrenderer" */ "@ms/uno-teamstasks-web/lib/ui/adapter/render"));
export const LazyLegacyTT = /*#__PURE__*/ lazy(()=>loadLegacyTTRenderer().then((mod)=>{
        return {
            default: ()=>mod.LegacyTTViewRenderer.render({
                    modalLayerHostId: "modalLayerHostId"
                })
        };
    }));
